// Package imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Custom imports
import api from "../../Api/feathers-client";

// Initial State
const initialState = {
  siteConfig: {},
  defsCreatedAt: {},
  serverRole: ''
};

// Action to fetch defs
export const fetchSiteConfig = createAsyncThunk(
  "siteConfig/fetchSiteConfig",
  async (queryObj, thunkAPI) => {
    const response = await api.service("defs").find({
      query: queryObj,
    });
    if (response["data"].length == 0) {
      return {};
    }
    return response["data"][0];
  }
);

export const fetchServerEnv = createAsyncThunk(
  'serverRole/fetchServerEnv',
  async (queryObj, thunkAPI) => {
    console.log("queryObj",queryObj);
      const response = await api.service('files-read').find({
        query: {
          envName: queryObj.envName
        }
      });
      return response;
});


// Redux Slice for Defs
const defsSlice = createSlice({
  name: "defs",
  initialState,
  reducers: {
    setDefs(state, { payload }) {
      state.siteConfig = payload.keydata;
      state.defsCreatedAt = payload.createdAt;
    },
    setServerRole(state, {payload}){
      return {
        ...state,
        serverRole: payload
      }
    }
  },
  extraReducers: {
    [fetchSiteConfig.fulfilled]: (state, { payload }) => {
      state.siteConfig = payload.keydata;
      state.defsCreatedAt = payload.createdAt;
    },
    [fetchServerEnv.fulfilled]: (state, { payload }) => {
      state.serverRole = payload;
    }
  },
});

export const defsSliceActions = defsSlice.actions;

export default defsSlice;
